import React from "react";
import { Box, Button, Container, Paper, Typography } from "@mui/material";
import { useFeature } from "components/feature";
import { Viewer } from "components/auth/types";
import { Feature } from "types/gql-types";

const AccessDenied: React.FC = () => (
  <Box sx={{ py: 4, display: "flex", justifyContent: "center" }}>
    <Container maxWidth="sm">
      <Paper sx={{ p: 3, textAlign: "center" }}>
        <Typography variant="h6" sx={{ mb: 1 }}>Access denied</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          You do not have permission to view contracts.
        </Typography>
        <Button variant="contained" href="/dash/manager/settings/organization">Back to settings</Button>
      </Paper>
    </Container>
  </Box>
);

type Props = {
  viewer: Viewer;
  children: React.ReactNode;
}

/** Plan-selection feature plus supervisor, Haven admin, or property manager. */
export const ManagerContractsRouteGate: React.FC<Props> = ({ viewer, children }) => {
  const planSelection = useFeature(Feature.PLAN_SELECTION);
  const allowed = planSelection && (
    viewer.isSupervisor || viewer.isAdmin || viewer.isPropManager
  );
  if (!allowed) return <AccessDenied />;
  return <>{children}</>;
};
